import api from './api';

const especialistaService = {
  // Obtener todos los especialistas
  getEspecialistas: async () => {
    try {
      const response = await api.get('/especialistas');
      return response;
    } catch (error) {
      console.error('Error obteniendo especialistas:', error);
      throw error;
    }
  },

  /*
    getEspecialistasPorEspecialidad: async (especialidadId) => {
      try {
        const response = await api.get(`/especialistas/por-especialidad/${especialidadId}`);
        return response;
      } catch (error) {
        console.error('Error fetching especialistas por especialidad:', error);
        throw error;
      }
    },
  */

  // Obtener un especialista por ID
  getEspecialista: async (id) => {
    try {
      const response = await api.get(`/especialistas/${id}`);
      return response;
    } catch (error) {
      console.error(`Error obteniendo especialista ${id}:`, error);
      throw error;
    }
  },

  // Crear nuevo especialista
  createEspecialista: async (data) => {
    try {
      const response = await api.post('/especialistas', data);
      return response;
    } catch (error) {
      console.error('Error creando especialista:', error);
      throw error;
    }
  },

  // Actualizar especialista
  updateEspecialista: async (id, data) => {
    try {
      const response = await api.put(`/especialistas/${id}`, data);
      return response;
    } catch (error) {
      console.error(`Error actualizando especialista ${id}:`, error);
      throw error;
    }
  },

  // Eliminar especialista
  deleteEspecialista: async (id) => {
    try {
      const response = await api.delete(`/especialistas/${id}`);
      return response;
    } catch (error) {
      console.error(`Error eliminando especialista ${id}:`, error);
      throw error;
    }
  },
  
  // Obtener especialistas por especialidad
  getEspecialistasPorEspecialidad: async (especialidadId) => {
    try {
      const response = await api.get(`/especialidades/${especialidadId}/especialistas`);
      return response;
    } catch (error) {
      console.error(`Error obteniendo especialistas para especialidad ${especialidadId}:`, error);
      throw error;
    }
  },
  
  // Asignar especialista a paciente
  asignarPaciente: async (especialistaId, pacienteId, data) => {
    try {
      const response = await api.post(`/especialistas/${especialistaId}/pacientes/${pacienteId}`, data);
      return response;
    } catch (error) {
      console.error(`Error asignando paciente ${pacienteId} a especialista ${especialistaId}:`, error);
      throw error;
    }
  },
  
  // Obtener pacientes asignados a un especialista
  getPacientes: async (especialistaId) => {
    try {
      const response = await api.get(`/especialistas/${especialistaId}/pacientes`);
      return response;
    } catch (error) {
      console.error(`Error obteniendo pacientes del especialista ${especialistaId}:`, error);
      throw error;
    }
  },

  getDisponibilidad: async (especialistaId, fechaInicio, fechaFin) => {
    return await api.get(`/especialistas/${especialistaId}/disponibilidad`, {
      params: { fecha_inicio: fechaInicio, fecha_fin: fechaFin }
    });
  },


  // 🆕 GESTIÓN DE HORARIOS NO LABORABLES
  
  // Obtener horarios configurados de un especialista
  getHorariosEspecialista: async (especialistaId) => {
    try {
      const response = await api.get(`/especialistas/${especialistaId}/horarios`);
      return response;
    } catch (error) {
      console.error(`Error obteniendo horarios del especialista ${especialistaId}:`, error);
      throw error;
    }
  },

  // Actualizar horarios de un especialista
  updateHorariosEspecialista: async (especialistaId, horarios) => {
    try {
      const response = await api.put(`/especialistas/${especialistaId}/horarios`, { horarios });
      return response;
    } catch (error) {
      console.error(`Error actualizando horarios del especialista ${especialistaId}:`, error);
      throw error;
    }
  },

  // Verificar si una hora específica está bloqueada
  verificarHoraBloqueada: async (especialistaId, fecha, hora) => {
    try {
      const response = await api.get(`/especialistas/${especialistaId}/hora-bloqueada`, {
        params: { fecha, hora }
      });
      return response;
    } catch (error) {
      console.error(`Error verificando hora bloqueada:`, error);
      throw error;
    }
  }
  
};

export default especialistaService;